// extracted by mini-css-extract-plugin
export default {"main":"TwelvedataIncomeStatement_main__bJ1Z2"};